@if(integrationsMap() === null) {
  <div class="loading-display">
    <app-lt-spinner></app-lt-spinner>
  </div>
} @else {

  @if(clients() && !gettingClients()) {
    @if(isInTab() === false) {
      <h3 class="center-text">Integration Errors</h3>
    } @else {
      <h4 class="center-text mt-1 mb-3">Integration Errors</h4>
    }

    <mat-tab-group class="error-tabs mt-2" #tabstrip
        animationDuration="10ms"
        mat-align-tabs="center"
        (selectedTabChange)="onTabSelect($event)">
        @if(isInTab() === false){
          <mat-tab label="Critical Errors">
            <div class="tab-content">
              <app-basic-error-search-filter
                [isSnapShot]="true"
                [categories]="categories()"
                [errorSearchFilter]="critErrorSearchFilter()"
                (updateFilter)="critErrorSearchFilter.set($event)">
              </app-basic-error-search-filter>

              @if(!criticalPopulated()){
                <div class="loading-display">
                  <app-lt-spinner></app-lt-spinner>
                </div>
              } @else {
                <div class="mt-2">
                  <app-lt-errors-grid
                    [data]="criticalErrorsList()"
                    [integrationsMap]="integrationsMap()"
                    [categories]="categories()"
                    [importTypes]="importTypes()"
                    [statuses]="statuses()"
                    [loading]="dataLoading()"
                    [clients]="clients()"
                    [destinations]="allDestinations()"
                    [sorts]="critErrorSorts"
                    (errorUpdated)="handleUpdatedIntegrationErrorFromGrid($event, 'critical')">
                  </app-lt-errors-grid>
                </div>
              }
            </div>
          </mat-tab>
        }

        <mat-tab label="All Errors">
          <div class="tab-content">
            @if(integration() == null) {
              <div>
                <app-basic-error-search-filter
                  [isSnapShot]="false"
                  [categories]="categories()"
                  [errorSearchFilter]="allErrorSearchFilter()"
                  (updateFilter)="allErrorSearchFilter.set($event)">
                </app-basic-error-search-filter>
              </div>
            }

            @if(!allPopulated()){
              <div class="loading-display">
                <app-lt-spinner></app-lt-spinner>
              </div>
            } @else {
              <div class="mt-2">
                <app-lt-errors-grid
                  [data]="allErrorsList()"
                  [integrationsMap]="integrationsMap()"
                  [categories]="categories()"
                  [importTypes]="importTypes()"
                  [statuses]="statuses()"
                  [loading]="dataLoading()"
                  [clients]="clients()"
                  [destinations]="allDestinations()"
                  [sorts]="allErrorSorts"
                  (errorUpdated)="handleUpdatedIntegrationErrorFromGrid($event, 'all')">
                </app-lt-errors-grid>
              </div>
            }
          </div>
        </mat-tab>

        @if(isInTab() === false){
          <mat-tab label="Service Errors">
            <div class="tab-content">
              @if(!serviceErrorsPopulated()){
                <div class="loading-display">
                  <app-lt-spinner></app-lt-spinner>
                </div>
              } @else {
                <div class="mt-2">
                  <app-lt-service-errors-grid
                    [data]="serviceErrorList()"
                    [integrationsMap]="integrationsMap()"
                    [categories]="categories()"
                    [statuses]="statuses()"
                    [loading]="dataLoading()"
                    [clients]="clients()"
                    (errorUpdated)="handleUpdatedServiceErrorFromGrid($event)">
                  </app-lt-service-errors-grid>
                </div>
              }
            </div>
          </mat-tab>
        }
    </mat-tab-group>
  }
}
